import { Box, Stack } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';

interface ZeroStateActionCardProps {
  icon: ReactNode;
  name: string;
  description: string;
  onClick: () => void;
  isActive?: boolean;
}

export const ZeroStateActionCard = ({
  icon,
  name,
  description,
  onClick,
  isActive = false,
}: ZeroStateActionCardProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        padding: '24px',
        border: `1px solid ${isActive ? colors.blue[500] : colors.grey[300]}`,
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: isActive ? colors.grey[100] : colors.white,
        flex: 1, // Equal width for cards in a row
        '&:hover, &:active': {
          backgroundColor: colors.grey[100],
          borderColor: colors.blue[500],
        },
      }}
    >
      <Stack alignItems="center" textAlign="center" gap={1}>
        <Stack p={0.5}>{icon}</Stack>

        <Stack alignItems="center" textAlign="center" gap={0.5}>
          <Typography variant="h4-medium" color={colors.grey[900]}>
            {name}
          </Typography>

          <Typography variant="h5" color={colors.grey[700]}>
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
